import { organizationTypes } from '../constants/action-types'

const initialState = {
  newOrganizationName: '',
  newOrganizationCUIT: '',
  newOrganizationType: null,
  newOrganizationLegalName: '',
  searchValueCUIT: null,
  searchValueName: null,
  selectTypeFilter: null,
  organizationDetails: {},
  types: [],
  organizations: null,
  usersOfSuscriber: [],
  suscriber: null,
  user: null
}

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case organizationTypes.ORGANIZATION_TYPE_REQUEST:
      return {
        ...state,
        newOrganizationType: []
      }

    case organizationTypes.ORGANIZATION_TYPE_SUCCESS:
      return {
        ...state,
        newOrganizationType: action.payload
      }
    case organizationTypes.ORGANIZATION_NAME_REQUEST:
      return {
        ...state,
        newOrganizationName: ''
      }
    case organizationTypes.ORGANIZATION_NAME_SUCCESS:
      return {
        ...state,
        newOrganizationName: action.payload
      }
    case organizationTypes.ORGANIZATION_CUIT_REQUEST:
      return {
        ...state,
        newOrganizationCUIT: ''
      }
    case organizationTypes.ORGANIZATION_CUIT_SUCCESS:
      return {
        ...state,
        newOrganizationCUIT: action.payload
      }
    case organizationTypes.ORGANIZATION_LEGALNAME_REQUEST:
      return {
        ...state,
        newOrganizationLegalName: ''
      }
    case organizationTypes.ORGANIZATION_LEGALNAME_SUCCESS:
      return {
        ...state,
        newOrganizationLegalName: action.payload
      }
    case organizationTypes.ORGANIZATION_TYPES_REQUEST:
      return {
        ...state,
        types: [],
        error: ''
      }
    case organizationTypes.ORGANIZATION_TYPES_SUCCESS:
      return {
        ...state,
        types: action.payload
      }
    case organizationTypes.ORGANIZATION_TYPES_FAILURE:
      return {
        ...state,
        types: [],
        error: action.payload
      }
    case organizationTypes.ORGANIZATION_ALL_REQUEST:
      return {
        ...state,
        organizations: [],
        error: ''
      }
    case organizationTypes.ORGANIZATION_ALL_SUCCESS:
      return {
        ...state,
        organizations: action.payload
      }
    case organizationTypes.ORGANIZATION_ALL_FAILURE:
      return {
        ...state,
        organizations: [],
        error: action.payload
      }
    case organizationTypes.ORGANIZATION_WITHID_REQUEST:
      return {
        ...state,
        organizationDetails: {},
        error: ''
      }
    case organizationTypes.ORGANIZATION_WITHID_SUCCESS:
      return {
        ...state,
        organizationDetails: action.payload
      }
    case organizationTypes.ORGANIZATION_WITHID_FAILURE:
      return {
        ...state,
        organizationDetails: {},
        error: action.payload
      }
    case organizationTypes.ORGANIZATION_USERS_REQUEST:
      return {
        ...state,
        users: []
      }
    case organizationTypes.ORGANIZATION_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload
      }
    case organizationTypes.ORGANIZATION_USERS_FAILURE:
      return {
        ...state,
        users: []
      }
    case organizationTypes.ORGANIZATION_GET_USERS_SUSCRIBER_REQUEST:
      return {
        ...state,
        usersOfSuscriber: []
      }
    case organizationTypes.ORGANIZATION_GET_USERS_SUSCRIBER_SUCCESS:
      return {
        ...state,
        usersOfSuscriber: action.payload
      }
    case organizationTypes.ORGANIZATION_GET_USERS_SUSCRIBER_FAILURE:
      return {
        ...state,
        usersOfSuscriber: []
      }
    case organizationTypes.ORGANIZATION_SET_SUSCRIBER_REQUEST:
      return {
        ...state,
        suscriber: null
      }
    case organizationTypes.ORGANIZATION_SET_SUSCRIBER_SUCCESS:
      return {
        ...state,
        suscriber: action.payload
      }
    case organizationTypes.ORGANIZATION_SET_USER_OF_SUBSCRIBER_REQUEST:
      return {
        ...state,
        user: null
      }
    case organizationTypes.ORGANIZATION_SET_USER_OF_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        user: action.payload
      }
       case organizationTypes.ORGANIZATION_ADD_SEARCH_VALUE_CUIT:
      return {
        ...state,
        searchValueCUIT: action.payload,
        searchValueName: null
      }
      case organizationTypes.ORGANIZATION_DELETE_SEARCH_VALUE_CUIT:
      return {
        ...state,
        searchValueCUIT: null
      }
    case organizationTypes.ORGANIZATION_SET_SEARCH_NAME_VALUE:
      return {
        ...state,
        searchValueName: action.payload,
         searchValueCUIT: null
      }
      case organizationTypes.ORGANIZATION_DELETE_SEARCH_NAME_VALUE:
        return {
          ...state,
          searchValueName: null
         
        }
      case organizationTypes.ORGANIZATION_SET_SELECTED_TYPES_ORG:
        return {
          ...state,
          selectTypeFilter: action.payload
        }

    default:
      return state
  }
}

export default organizationReducer
